/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'save': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M14.167 2.5h-10c-.925 0-1.667.75-1.667 1.667v11.666c0 .917.742 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667v-10L14.167 2.5zM10 15.833a2.497 2.497 0 01-2.5-2.5c0-1.383 1.117-2.5 2.5-2.5s2.5 1.117 2.5 2.5c0 1.384-1.117 2.5-2.5 2.5zM12.5 7.5H4.167V4.167H12.5V7.5z" _fill="#fff"/>'
  }
})
